import { render } from "./ProfiloApp.vue?vue&type=template&id=14e51c11"
import script from "./ProfiloApp.vue?vue&type=script&lang=js"
export * from "./ProfiloApp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andreavadacchino/Desktop/pADV/untitled/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__